//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { maxLength, required } from 'vuelidate/lib/validators';
import debounce from 'lodash.debounce';
import { faChevronDown, faCheck } from '@fortawesome/pro-regular-svg-icons';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string';
import PredictionMixin from '@/components/mixins/prediction.mixin.js';
import useMarketplaceProductsMixin from '@/components/mixins/use-marketplace-products.mixin.js';

export default {
  name: 'ImageVariations',
  mixins: [AiToolsMixin, PredictionMixin, featureFlagMixin, useMarketplaceProductsMixin],
  components: {
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceImage: () => import('@/components/tools/SourceImage.vue'),
    DemoSourceImages: () => import('@/components/tools/DemoSourceImages.vue'),
    SelectButtons: () => import('@/components/tools/SelectButtons.vue'),
    PromptTextarea: () => import('@/components/tools/PromptTextarea.vue'),
    // BaseSelect: () => import('@motionelements/core/src/components/ui/form/BaseSelect.vue'),
    BaseSelect: () => import('@/components/core/BaseSelect.vue'),
  },
  data() {
    return {
      faChevronDown,
      faCheck,
      //
      form: {
        model: 'image_variation',
        image: null,
        variationStrength: 100,
        prompt: '',
        numOutputs: 4,
        type: 'flux_pro',
      },
      prediction: {
        model: 'image_variation',
        image: null,
        variationStrength: 100,
        prompt: '',
        numOutputs: 4,
      },
      demoImage: null,
      variationStrengthValues: [
        {
          value: 50,
          title: '50%',
        },
        {
          value: 80,
          title: '80%',
        },
        {
          value: 100,
          title: '100%',
        },
      ],
      demoImages: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/image_variations/thumbnails/thumbnail1.jpg?auto=format&w=88',
          value: 'ImageVariation_sample1',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/image_variations/thumbnails/thumbnail2.jpg?auto=format&w=88',
          value: 'ImageVariation_sample2',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/image_variations/thumbnails/thumbnail3.jpg?auto=format&w=88',
          value: 'ImageVariation_sample3',
        },
      ],
    };
  },
  validations: {
    form: {
      image: {
        required: required,
      },
      prompt: {
        required: required,
        maxLength: maxLength(1000),
      },
    },
  },
  computed: {
    ...mapGetters({
      aiToolModels: 'aiTools/aiToolModels',
    }),
    tool() {
      return this.aiTools.find(({ id }) => id === this.aiToolsIds.IMAGE_VARIATIONS);
    },
    demoOutput() {
      if (this.demoImage) {
        const imagePath = `https://static.moele.me/img/studio-ai/${this.aiToolsIds.IMAGE_VARIATIONS}/output/${this.demoImage}`;
        return Array(4).fill(imagePath).map((item, index) => {
          if (index === 0) {
            return { preview: { url: `${item}.jpg?auto=format&w=524` } };
          }
          return { preview: { url: `${item}-${index}.jpg?auto=format&w=524` } };
        });
      }
      return null;
    },
  },
  watch: {
    form: {
      handler: debounce(function (val, oldVal) {
        console.log('========= WATCH form ', oldVal, val);
        if (!this.$v.form.$invalid) {
          this.tryToEstimate();
        }
      }, 500),
      deep: true,
    },
  },
  methods: {
    clearForm() {
      this.form.type = 'flux-pro';
      this.form.image = null;
      this.demoImage = null;
      this.form.prompt = '';
      this.price = false;
    },
    setFormFromResponse(response) {
      this.form.type = _.get(response, 'input.type');
      this.form.image = _.get(response, 'input.image');
      this.form.prompt = _.get(response, 'input.prompt');
      this.form.variationStrength = _.get(response, 'input.variationStrength');
      this.prediction.image = _.get(response, 'input.image');
      this.prediction.prompt = _.get(response, 'input.prompt');
      this.prediction.variationStrength = _.get(response, 'input.variationStrength');
    },
    tryToEstimate() {
      this.getPredictionEstimate(snakeCaseKeys(this.form));
    },
  },
};
